/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getSessions = (schoolId) =>
  client.get(`/staff/school/${schoolId}/sessions`);

const getSession = (sessionId, schoolId) =>
  client.get(`/staff/school/${schoolId}/sessions/${sessionId}`);

export default {
  getSession,
  getSessions,
};
